import { InfoIcon } from '@chakra-ui/icons'
import {
  Button,
  Checkbox,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { ReactNode, useState } from 'react'

type Props = {
  isOpen: boolean
  agreementType: '利用規約' | 'プライバシーポリシー'
  url: string
  buttonLoading: boolean
  children: ReactNode
  okFunction: (bool: boolean) => void
}

export const CommonModal = ({
  isOpen,
  agreementType,
  url,
  buttonLoading,
  children,
  okFunction,
}: Props) => {
  const [isChecked, setIsChecked] = useState(false)

  return (
    <Modal size="lg" isOpen={isOpen} onClose={() => {}}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <InfoIcon mr="4" />
          {agreementType}が新しくなりました
        </ModalHeader>
        <ModalBody py="8">
          {children}
          <Checkbox
            mt={5}
            defaultChecked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          >
            <Text onClick={(e) => e.preventDefault()}>
              <Text
                as={'span'}
                color={'blue.500'}
                textDecoration={'underline'}
                onClick={() => window.open(url, '_blank')}
              >
                {agreementType}
              </Text>
              に同意します
            </Text>
          </Checkbox>
        </ModalBody>
        <ModalFooter>
          <Button
            mr={3}
            size="md"
            isDisabled={!isChecked}
            isLoading={buttonLoading}
            colorScheme="brandSecondary"
            onClick={() => okFunction(isChecked)}
          >
            同意して利用する
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
